

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App'
import router from './router'
import store from './store/store'
import fastClick from 'fastclick'

fastClick.attach(document.body)

Vue.use(Vuex)
Vue.use(WechatPlugin)
Vue.use(Vant)
Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
const vm = new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})

global.vm = vm



// WEBPACK FOOTER //
// ./src/main.js